/**
 * Created by sky on 2019/3/29.
 */
import * as init from './init';

const Api={
    init
}
export default Api;
